import React from 'react'
import { connect } from 'react-redux'

class RedirectOut extends React.Component {
  componentDidMount(){
    window.location.replace(this.props.route.link);
  }

  render() {
    return (
      <div className='sales-page-container flex-column align-center'>
      </div>
    );
  }
}

RedirectOut.displayName = 'RedirectOut';

export default connect()(RedirectOut);


// WEBPACK FOOTER //
// ./src/components/landingPages/RedirectOut.js